import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input, OnInit } from '@angular/core';
import { ReactiveFormsModule, UntypedFormBuilder, Validators } from '@angular/forms';
import { MemberIdentifier } from '@app/core/_models/member-interface';
import { SessionService } from '@app/core/session/session.service';
import { LoginService } from '@app/+login/login.service';
import { ActivatedRoute } from '@angular/router';
import { PASSWORD_INVALID_ERROR_KEY, PASSWORD_REQUIRED_ERROR_KEY } from '@app/+login/deprecated-hybrid/consts';
import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { TranslatePipe } from '@ngx-translate/core';
import { PasswordInputComponent } from '@app/+login/components/password-input/password-input.component';
import { RecaptchaInfoComponent } from '@app/core/recaptcha/components/recaptcha-info/recaptcha-info.component';

@Component({
  selector: 'app-msisdn-otp',
  templateUrl: './msisdn-otp.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    TranslatePipe,
    ReactiveFormsModule,
    PasswordInputComponent,
    RecaptchaInfoComponent,
  ],
})
export class MsisdnOTPComponent implements OnInit {
  @Input() public identifier?: MemberIdentifier;

  public submitted = false;
  public isLoading = false;

  public form = this.formBuilder.group({
    password: ['', Validators.required],
  });

  public formErrors: { error?: string } = {};

  private unsubscribe$ = new Subject();

  constructor(private route: ActivatedRoute,
              private formBuilder: UntypedFormBuilder,
              private loginService: LoginService,
              private sessionService: SessionService,
              private cdr: ChangeDetectorRef) { }


  public ngOnInit(): void {
    this.clearFormErrorsOnValueChange();
  }

  public onSubmit(): void {
    this.submitted = true;

    if (this.form.get('password')?.invalid) {
      this.formErrors = { error: PASSWORD_REQUIRED_ERROR_KEY };
      return;
    }


    this.signIn();
  }

  private signIn(): void {
    this.sessionService.deprecatedSignIn(
      this.identifier,
      this.form.value.password.trim(),
      this.sessionService.getOtpSecret(),
    ).subscribe(
      () => this.loginService.afterSignedIn(this.route.parent),
      (response) => {
        this.isLoading = false;
        if (response.status === 401) {
          this.formErrors = { error: PASSWORD_INVALID_ERROR_KEY };
          this.cdr.detectChanges();
        }
      },
    );
  }

  private clearFormErrorsOnValueChange(): void {
    this.form.valueChanges.pipe(
      takeUntil(this.unsubscribe$),
    ).subscribe(() => this.formErrors = {});
  }
}
